import consts, { TypeCanvasElement } from "shared/consts";
import GanttElementProvider from "elements/gantt/provider";
import { elementGraphicsProvidersRegistry, elementProvidersRegistry } from "elements/registry";
import GanttGraphicsProvider from "elements/gantt/graphics";
import type { Reflect } from "@workcanvas/reflect/client";
import type { M } from "shared/datamodel/mutators";
import UndoRedoStack from "utils/undo-redo/undo-redo-stack";
import { CheckoutSources } from "frontend/billing/checkout";
import { CanvasState } from "frontend/canvas-designer-new/canvas-stage";
import { Channel } from "pusher-js";
import IconElementProvider from "./icon/provider";
import IconGraphicsProvider from "./icon/graphics";
import PdfElementProvider from "./pdf/provider";
import PdfGraphicsProvider from "./pdf/graphics";
import { ReactNode } from "react";
import ChartProvider from "./chart/chart-provider";
import ChartGraphicsProvider from "./chart/graphics";
import { FeatureFlagsValues } from "frontend/hooks/use-feature-flag/flags";
import { IntegrationItemsMap } from "frontend/hooks/use-board-integrations.types";
import TaskElementProvider from "./task/provider";
import TaskGraphicsProvider from "./task/graphics";
import MondayTaskElementProvider from "./monday-task/provider";
import MondayTaskGraphicsProvider from "./monday-task/graphics";

export interface BoardContext {
  boardId: number;
  documentId: string;
  isReadOnly: boolean;
  isLoggedIn: boolean;
  reflect?: Reflect<M> | null;
  selectedElementIds: string[];
  setSelectedIds: (ids: string[], includeGroupsOfElements?: boolean) => void;
  setStageState: React.Dispatch<React.SetStateAction<Partial<CanvasState>>>;
  hiddenElementIds: string[];
  editingElementId: string | null;
  editingElementLinkId: string | null;
  undoRedoStack?: UndoRedoStack;
  showUpgradeModal?: (reason: CheckoutSources) => void;
  pusherChannel?: Channel;
  showErrorToast?: ((error: ReactNode | null) => void) | undefined;
  allFeatureFlags?: FeatureFlagsValues;
  dataSource?: IntegrationItemsMap;
}

export function getElementProvider(type: TypeCanvasElement) {
  return elementProvidersRegistry.getProvider(type);
}

export function getElementGraphicsProvider(type: TypeCanvasElement) {
  return elementGraphicsProvidersRegistry.getProvider(type);
}

// Providers
elementProvidersRegistry.registerProvider(consts.CANVAS_ELEMENTS.GANTT, new GanttElementProvider());
elementProvidersRegistry.registerProvider(consts.CANVAS_ELEMENTS.CHART, new ChartProvider());
elementProvidersRegistry.registerProvider(consts.CANVAS_ELEMENTS.ICON, new IconElementProvider());
elementProvidersRegistry.registerProvider(consts.CANVAS_ELEMENTS.TASK, new TaskElementProvider());
elementProvidersRegistry.registerProvider(consts.CANVAS_ELEMENTS.MONDAY_TASK, new MondayTaskElementProvider());
elementProvidersRegistry.registerProvider(consts.CANVAS_ELEMENTS.PDF, new PdfElementProvider());

// Graphics providers
elementGraphicsProvidersRegistry.registerProvider(consts.CANVAS_ELEMENTS.GANTT, new GanttGraphicsProvider());
elementGraphicsProvidersRegistry.registerProvider(consts.CANVAS_ELEMENTS.CHART, new ChartGraphicsProvider());
elementGraphicsProvidersRegistry.registerProvider(consts.CANVAS_ELEMENTS.ICON, new IconGraphicsProvider());
elementGraphicsProvidersRegistry.registerProvider(consts.CANVAS_ELEMENTS.TASK, new TaskGraphicsProvider());
elementGraphicsProvidersRegistry.registerProvider(consts.CANVAS_ELEMENTS.MONDAY_TASK, new MondayTaskGraphicsProvider());
elementGraphicsProvidersRegistry.registerProvider(consts.CANVAS_ELEMENTS.PDF, new PdfGraphicsProvider());
